module.exports = __webpack_public_path__ + "static/media/Alert.40a3ffa8.png";